import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Bullets, Inputs } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import useValidateClabe, { getErrorContext, hasError } from 'Hooks/useValidateClabe';
import { CLABE_HELP_URL } from 'Constants/helpsUrl';
import { openLinkInNewTab } from 'Utils/links';
import { ClabeInputProps } from './types';

const ClabeInput = ({ data, setClabeAccount, clabeAccount }: ClabeInputProps): JSX.Element => {
  const { isValid, error, bankTag, isLoading } = useValidateClabe(clabeAccount || '');
  const { t } = useTranslation(locizeNS.FILING);
  const info = useSelector(routeStateSelector);

  useEffect(() => {
    if (data?.prefilledCLABE) {
      setClabeAccount(data.prefilledCLABE);
    }
  }, [data]);

  const handleChange = (val): void => {
    setClabeAccount(val.replace(/\s+/g, ''));
  };

  return (
    <>
      <Inputs.Text
        label={t('ClabeForm.Clabe.label', { context: `${info?.taxReturnType}` })}
        value={clabeAccount}
        hasError={!isLoading && hasError(clabeAccount, isValid)}
        onChange={handleChange}
        placeholder={t('Filing.clabe.placeholder')}
        errorMsg={t(`Filing.clabe.${getErrorContext(clabeAccount, error)}`)}
        helpButtonUrl={CLABE_HELP_URL}
        onHelpButton={url => openLinkInNewTab(url)}
      />
      {clabeAccount && isValid && (
        <Bullets
          bullets={[
            {
              text: t('Filing.clabe.tag', {
                info: bankTag,
              }),
            },
          ]}
          icon={{
            type: 'InfoXS',
          }}
          spacing="S"
        />
      )}
    </>
  );
};

export default ClabeInput;
